import React, { useState, useEffect } from 'react'
import AnnouncementHead from './AnnouncementHead'
import AnnouncementMsg from './AnnouncementMsg'
import Header from './Header'
import ModalInformation from './ModalInformation'
import Chat from './IframChat'
import Wating from './Wating'
import { isEmpty, isNull } from 'lodash'
import AuthRucket from './AuthRocketJWT'
import { useDispatch, useSelector } from 'react-redux'
import { getCookie } from '../../helpers'
import { Tabs } from 'antd'
import { SET_CONNECT_LOBBY, SHOW_POPUP } from '../../redux/actions/type'

const Participant = ({ roomName, jwt, reservationId }) => {
    const [showModal, setshowModal] = useState(true)
    const isConnect = useSelector(state => state.lobby.connecting)
    const announcement = useSelector(state => state.lobby.announcement)
    const [screenWidth, setScreenWidth] = useState(0)
    const { TabPane } = Tabs;
    const [activeTabPane, setActiveTabPane] = useState('1')
    const [activeTime, setActiveTime] = useState(null)
    const dispatch = useDispatch()


    const handleIframeChat = () => {
        const rocketChatInfo = getCookie('rocketChatInfo') ? JSON.parse(getCookie('rocketChatInfo')) : {}
        if (!isEmpty(rocketChatInfo) && isConnect) {
            return <Chat isConnect={isConnect} />
        }
    }

    const handleAuthState = () => {
        if (!isEmpty(jwt)) {
            return <AuthRucket
                roomName={roomName}
                jwt={jwt}
                reservationId={reservationId}
            />
        } else {
            return <ModalInformation
                roomName={roomName}
                showModal={showModal}
                setshowModal={setshowModal}
                reservationId={reservationId}
            />

        }
    }

    useEffect(() => {
        document.body.style.setProperty('background-color', '#fff', 'important')
    })

    useEffect(() => {
        onLayoutHeight()
        window.addEventListener('resize', onLayoutHeight);
    })

    useEffect(() => {
        if (isConnect) {
            setActiveTabPane('2')
        }
    }, [isConnect])

    /**
     * set window active time
     */
    useEffect(() => {
        const currrentTime = Date.parse(new Date())
        setActiveTime(currrentTime)
        localStorage.setItem('windowActiveTime', currrentTime)
    }, [])

    useEffect(() => {
        setInterval(() => {
            const getActiveTime = localStorage.getItem('windowActiveTime')
            if (parseInt(activeTime) < parseInt(getActiveTime)) {
                setshowModal(false)
                dispatch({
                    type: SET_CONNECT_LOBBY,
                    payload: {
                        connecting: false
                    }
                })
                dispatch({
                    type: SHOW_POPUP,
                    payload: {
                        isShow: true,
                        textBody: 'popupInfo.duplicate_tap',
                        action: `${window._env_.vRoomUrl}/portal`
                    }
                })
            }
        }, 1000);
    }, [activeTime, dispatch])

    const onLayoutHeight = () => {
        const participantAlert = document.getElementsByClassName('participant-alert')
        const participantWatingBox = document.getElementsByClassName('participant-wating-box')
        if (participantAlert[0] && participantWatingBox[0]) {
            if (window.innerWidth < 1024)
                participantWatingBox[0].style.minHeight = `${window.innerHeight - (participantAlert[0].offsetHeight + 170)}px`
        }
        return setScreenWidth(window.innerWidth)
    }
    const handleTabclick = (key) => {
        setActiveTabPane(key);
    }
    return (
        !isNull(reservationId) ? (
            <div>
                <Header />
                {screenWidth < 1024
                    ? <Tabs onTabClick={handleTabclick} activeKey={activeTabPane} className="tabs-participant">
                        <TabPane tab="Waiting Room" key="1">
                            <AnnouncementHead jwt={jwt} />
                            <div className="participant-wating-box">
                                <Wating roomName={roomName} />
                                <AnnouncementMsg announcement={announcement} />
                            </div>
                        </TabPane>
                        <TabPane tab="Chat" disabled={!isConnect} key="2">
                            {handleIframeChat()}
                        </TabPane>
                    </Tabs>
                    : <div>
                        <AnnouncementHead jwt={jwt} />
                        <div className="participant-wating-box">
                            <Wating roomName={roomName} />
                            <AnnouncementMsg announcement={announcement} />
                        </div>
                        {handleIframeChat()}
                    </div>
                }
                {handleAuthState()}
            </div>
        ) : null
    )
}

export default Participant
